export enum TextWithBgAlign {
  Bottom,
  Left,
  Right,
  Top,
  TopLeft,
  BottomLeft,
}
